import {
  Divider,
  Paper,
  Typography,
  Stack,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import { planPeriods, userTypes } from "./constants";
import { useState } from "react";
import Atomic from "../../../AComponent/Atomic";
import TeamPlanTable from "./TeamPlanTable";

const { Dropdown } = Atomic;

const MyTeamPlan = () => {
  const [userType, setUserType] = useState("LR");
  const [period, setPeriod] = useState("2025-26");

  return (
    <Box sx={{ width: "100%" }}>
      <Stack rowGap={"1rem"} sx={{ width: "80em", margin: "0 auto" }}>
        <Typography variant="h4">My Team Plan</Typography>
        <Divider />
        <Paper>
          <Stack rowGap={"1rem"}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Tabs
                value={userType}
                onChange={(event, newValue) => {
                  console.log(event);
                  setUserType(newValue);
                }}
              >
                {userTypes.map((type) => (
                  <Tab key={type.value} label={type.label} value={type.value} />
                ))}
              </Tabs>
              <Dropdown
                value={period}
                onChange={(value) => {
                  if (value) {
                    setPeriod(value);
                  }
                }}
                menuItems={planPeriods}
                styles={{ width: "8rem" }}
                label={"Select Period"}
              />
            </Stack>
            {userType && period && (
              <TeamPlanTable relationshipType={userType} period={period} />
            )}
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};

export default MyTeamPlan;
